
import PictureFrame from "../../../assets/outline/PictureFrame.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PictureFrameIcon({ className, dataTestid = "PictureFrameIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PictureFrame data-testid={dataTestid} className={classes} {...rest} />
  );
}
